<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">


          <el-col :span="12">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select
              disabled
                v-model="form.nursinghomeId"
                style="width: 100%"
                placeholder="请选择服务网点"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          


          <el-col :span="12">
            <el-form-item label="类型名称" prop="name">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.name"
                placeholder="类型名称"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="是否主机" prop="isHostMachine">
              <el-select  :disabled="model==='view'" v-model="form.isHostMachine" placeholder="是否主机" style="width: 100%">
                <el-option
                  v-for="item in yesNoList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>



          <el-col :span="12">
            <el-form-item label="所属设备大类" prop="deviceCategory">
              <el-select
                 :disabled="model==='view'" v-model="form.deviceCategory"
                placeholder="所属设备大类"
                style="width: 100%"
              >
                <el-option
                  v-for="item in deviceCategoryList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="设备编码" prop="code">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.code"
                placeholder="设备编码"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>


          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                clearable
                 :disabled="model==='view'" v-model="form.remark"
                placeholder="备注"
                maxlength="300"
              ></el-input>
            </el-form-item>
          </el-col>


        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import { saveDeviceType, updateDeviceType, getNursinghome } from '../api/serveItemManage';
import { getDictionary } from '@/api/common.js';
export default {
  components: {},

  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],

      form: {
        name: '',
        sex: '',
        tel: '',
        adress: '',
        relationship: '',
        isWatch: '',
        code: '',
      },
      formRules: {
        name: [{ required: true, message: '类型名称不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '设备编码不能为空', trigger: 'blur' }],
        //   nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      yesNoList: [],
      nursinghomeIdList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    getGenderByIdNumber(idNumber) {
      if (idNumber) {
        let genderCode; // 性别代码
        if (idNumber.length == 18) {
          // 二代身份证号码长度为18位（第17位为性别代码）
          genderCode = idNumber.charAt(16);
        } else if (idNumber.length == 15) {
          // 一代身份证号码长度为15位（第15位为性别代码）
          genderCode = idNumber.charAt(14);
        }
        if (genderCode && !isNaN(genderCode)) {
          // 两代身份证号码的性别代码都为男奇女偶
          if (parseInt(genderCode) % 2 == 0) {
            return 'female';
          }
          return 'male';
        }
      }
    },

    async initData() {
      // getProjectList().then((res) => {
      //   this.projectList = res.data;
      // });
      console.log(this.nursinghomeId,"nursinghomeId==========");
        this.form.nursinghomeId = this.nursinghomeId;
      if(this.model === 'add'){
      }else{
        this.form = this._.cloneDeep(this.row);
      }
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
      });
      getDictionary('nursinghome_device_category').then((res) => {
        this.deviceCategoryList = res.data;
      });
      getDictionary('yes_no').then((res) => {
        this.yesNoList = res.data;
      });
      if (this.model == 'add') {
      } else {
      }
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if(this.model==='add'){

            saveDeviceType(this.form).then((res)=>{
              this.$message.success('操作成功！');
            this.$emit('success', this.form);
            })
          }else{
            updateDeviceType(this.form).then((res)=>{
              this.$message.success('操作成功！');
            this.$emit('success', this.form);
            })
          }
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  